import { Flex } from '@grupoboticario/flora-react';
import { CrossIcon } from '@grupoboticario/flora-react-icons';
import config from 'config';

import {
  NOT_FOUND_CREDIT_CARD_FORM_CONST,
  type NotFoundCreditCardFormProps,
} from './NotFoundCreditCardForm.d';
import { CreditCardForm } from './NotFoundCreditCardForm.style';

const NotFoundCreditCardForm = ({
  onClickChangePayment,
  onClickToHome,
}: NotFoundCreditCardFormProps) => (
  <CreditCardForm.Component data-testid={NOT_FOUND_CREDIT_CARD_FORM_CONST.TEST_ID}>
    <Flex justify="center">
      <CrossIcon color="$error-standard" size="64" />
    </Flex>

    <CreditCardForm.Title level={6} textAlign="center">
      Tivemos um problema com seu pedido
    </CreditCardForm.Title>

    <CreditCardForm.Subtitle textAlign="center">
      Não foi possível realizar o pagamento com cartão de crédito e o pedido foi cancelado. Por
      favor, faça o pedido novamente.
    </CreditCardForm.Subtitle>

    <CreditCardForm.ButtonChangePayment onClick={onClickChangePayment} stretch>
      Fazer novo pedido
    </CreditCardForm.ButtonChangePayment>

    <CreditCardForm.ButtonToHome onClick={onClickToHome} stretch>
      Voltar para o portal {config.app.name}
    </CreditCardForm.ButtonToHome>
  </CreditCardForm.Component>
);

export default NotFoundCreditCardForm;
